export default __webpack_public_path__ + "static/media/zero-touches-production.6a38b1a5.svg";